import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[rdrxMatTabGroupDirective]',
  standalone: false,
})
export class MatTabGroupDirective {
  @Output() matTabGroupBlur = new EventEmitter<void>();

  @HostListener('focusout') onfocusout(): void {
    this.matTabGroupBlur.emit();
  }
}
